type CacheBustToken = string | number | Date | null | undefined;

function resolveTimestamp(token: CacheBustToken): number | null {
  if (token == null) return null;
  if (token instanceof Date) {
    const t = token.getTime();
    return Number.isFinite(t) ? t : null;
  }
  if (typeof token === "number") {
    return Number.isFinite(token) ? token : null;
  }
  const parsed = Date.parse(token);
  return Number.isFinite(parsed) ? parsed : null;
}

export function withCacheBust(url: string, token?: CacheBustToken): string {
  const ts = resolveTimestamp(token);
  if (ts === null) return url;
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}v=${ts}`;
}
